import React from 'react';
import './AM9109.css';
import { Helmet } from "react-helmet";
import img1 from '../Components/Images/antennas/concealed.png';
import img2 from '../Components/Images/antennas/concealed1.png';
import { FaShoppingCart, FaTshirt, FaMagic, FaGlasses, FaBaby, FaFemale, FaShoePrints } from 'react-icons/fa';
import { FiCheck } from 'react-icons/fi';
import './Concealeddeep.css'
function Concealeddeep() {
  return (
    <div className="concealed-page">
      <Helmet>
        <title>Floor Guard Concealed EAS System | Discreet Retail Security Solution</title>
        <meta name="description" content="Premium concealed EAS pedestal system for retail spaces. Invisible 58kHz security with 2m detection range. Maintain store aesthetics while preventing theft." />
        <meta name="keywords" content="concealed EAS system, floor security antenna, hidden retail security, AM 58kHz detection, anti-shoplifting solution, invisible theft prevention" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-grid">
            <div className="hero-image">
              <img 
                src={img1} 
                alt="Floor Guard concealed EAS system installed in retail floor" 
                className="img-fluid" 
                loading="lazy"
              />
            </div>
            <div className="hero-content">
              <h1>Floor Guard <span>Concealed Systems</span></h1>
              <p className="lead">
                Unobstructed access with maximum security. The ARGUS AM Floor System combines discreet design with advanced anti-theft protection.
              </p>
              <ul className="hero-features">
                <li>Completely hidden in floor construction</li>
                <li>2m detection range for hard tags</li>
                <li>Maintains store aesthetics</li>
                <li>Remote monitoring capabilities</li>
              </ul>
              <button className="cta-button">Get a Custom Quote</button>
            </div>
          </div>
        </div>
      </section>

      {/* Applications Section */}
      <section className="applications-section">
        <div className="container">
          <h2 className="section-title">Ideal For</h2>
          <div className="applications-grid">
            <div className="application-card">
              <div className="app-icon">
                <FaShoppingCart />
              </div>
              <p>Supermarkets</p>
            </div>
            <div className="application-card">
              <div className="app-icon">
                <FaTshirt />
              </div>
              <p>Clothing Stores</p>
            </div>
            <div className="application-card">
              <div className="app-icon">
                <FaMagic />
              </div>
              <p>Cosmetic Stores</p>
            </div>
            <div className="application-card">
              <div className="app-icon">
                <FaGlasses />
              </div>
              <p>Optical Shops</p>
            </div>
            <div className="application-card">
              <div className="app-icon">
                <FaBaby />
              </div>
              <p>Infant Stores</p>
            </div>
            <div className="application-card">
              <div className="app-icon">
                <FaFemale />
              </div>
              <p>Boutiques</p>
            </div>
            <div className="application-card">
              <div className="app-icon">
                <FaShoePrints />
              </div>
              <p>Shoe Stores</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">Advanced Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <FiCheck />
              </div>
              <div className="feature-content">
                <h3>Invisible Security</h3>
                <p>Seamless integration maintains store aesthetics while providing robust protection against theft.</p>
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FiCheck />
              </div>
              <div className="feature-content">
                <h3>Powerful Detection</h3>
                <p>High-sensitivity 58kHz system detects hard tags up to 2 meters with minimal interference.</p>
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FiCheck />
              </div>
              <div className="feature-content">
                <h3>Remote Management</h3>
                <p>Real-time monitoring and remote debugging reduce maintenance costs and downtime.</p>
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FiCheck />
              </div>
              <div className="feature-content">
                <h3>Versatile Installation</h3>
                <p>Compatible with various flooring materials including tile, wood, and concrete.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Specifications Section */}
      <section className="specs-section">
        <div className="container">
          <h2 className="section-title">Technical Specifications</h2>
          <div className="specs-table">
            <div className="spec-row">
              <div className="spec-name">Model Number</div>
              <div className="spec-value">Floor Guard Concealed System</div>
            </div>
            <div className="spec-row">
              <div className="spec-name">Material</div>
              <div className="spec-value">PVC foam board</div>
            </div>
            <div className="spec-row">
              <div className="spec-name">Frequency</div>
              <div className="spec-value">58kHz</div>
            </div>
            <div className="spec-row">
              <div className="spec-name">Detection Range</div>
              <div className="spec-value">1.2m-2.0m (hard tags)</div>
            </div>
            <div className="spec-row">
              <div className="spec-name">Dimensions</div>
              <div className="spec-value">1600×600×20mm (Customizable)</div>
            </div>
            <div className="spec-row">
              <div className="spec-name">Power Consumption</div>
              <div className="spec-value">100W (25W per antenna)</div>
            </div>
          </div>
          <div className="specs-image">
            <img 
              src={img2} 
              alt="Technical diagram of concealed floor security system" 
              className="img-fluid"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <h2 className="section-title">Customer Experiences</h2>
          <div className="testimonial-card">
            <div className="rating">★★★★★</div>
            <p className="testimonial-text">
              "Since installing the Floor Guard system, we've seen a 75% reduction in shrinkage. The hidden design maintains our boutique's aesthetic while providing excellent protection."
            </p>
            <div className="customer-info">
              <div className="customer-name">Sarah Johnson</div>
              <div className="customer-title">Store Manager, Luxury Boutique</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Concealeddeep;